import { render, staticRenderFns } from "./messageVideo.vue?vue&type=template&id=703da1e4&scoped=true"
import script from "./messageVideo.vue?vue&type=script&lang=js"
export * from "./messageVideo.vue?vue&type=script&lang=js"
import style0 from "./messageVideo.vue?vue&type=style&index=0&id=703da1e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703da1e4",
  null
  
)

export default component.exports